export default __webpack_public_path__ + "static/media/icon-network-bitcoin.de67e82e.svg";